<template lang="html">

<div class="subComponent">

  <el-dialog
    title="新增上级事项"
    :visible.sync="openstate"
    @closed="closeHandle"
    @open="openHandle"
    width="720px"
    :before-close="handleClose">

    <div class="cbody">
        <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">

            <div class="text-block clearfix">
                <div class="bName">标题</div>
                <div class="bContent">
                      <el-form-item prop="title">
                            <el-input size="medium" v-model="params.title" placeholder="请输入内容"></el-input>
                      </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">主题分类</div>
                <div class="bContent">
                    <el-form-item prop="topicClassificationId">
                        <dic-select code="ztfl"
                             :selectId="params.topicClassificationId"
                             paramsKey="topicClassification"
                             @selectChange="selectChange"/>
                    </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">部门分类</div>
                <div class="bContent">
                    <el-form-item prop="departmentClassificationId">
                        <dic-select code="bmfl"
                             :selectId="params.departmentClassificationId"
                             paramsKey="departmentClassification"
                             @selectChange="selectChange"/>
                    </el-form-item>
                </div>
            </div>
            <div class="text-block clearfix">
                <div class="bName">生命周期分类</div>
                <div class="bContent">
                    <el-form-item prop="lifeCycleClassificationId">
                        <dic-select code="smzqfl"
                             :selectId="params.lifeCycleClassificationId"
                             paramsKey="lifeCycleClassification"
                             @selectChange="selectChange" />
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
        <el-button @click="openstate=false" size="small">取 消</el-button>
        <el-button @click="affCreate" size="small" type="primary">确 定</el-button>
    </div>
 </el-dialog>

</div>

</template>

<script>
import { affSave } from "@/api/affairs/affairs";
export default {
    data(){
        return{
            openstate:false,
            params:{
                id:'',
                level:1, // 层级关系
                type:1,  // 事项类型
                title:'',
                status:2,
                topicClassification:'',  // 主题分类
                topicClassificationId:'',

                departmentClassification:'',  // 部门分类
                departmentClassificationId:'',

                lifeCycleClassification:'', // 生命周期
                lifeCycleClassificationId:'',
            },
            rules:{
                title:[{
                    required: true,
                    trigger: 'change'
                }],
                topicClassificationId:[{
                    required: true,
                    trigger: 'change'
                }],
                departmentClassificationId:[{
                    required: true,
                    trigger: 'change'
                }],
                lifeCycleClassificationId:[{
                    required: true,
                    trigger: 'change'
                }]
            }
        }
    },
    methods:{
        affCreate:function(){
            var vues = this;
            affSave({handleMatters:this.params}).then(res => {
                vues.openstate = false;
                vues.$emit("upFrash");
            })
        },
        selectChange:function(eDat){
            if(eDat.name){
               this.params[eDat.paramsKey] = eDat.name;
               this.params[eDat.paramsKey + 'Id'] = eDat.id;
            }
        },
        openHandle:function(){
            if(this.$refs.ruleForm){
                this.$refs.ruleForm.clearValidate();
            }
        },
        closeHandle:function(){
            for(let key in this.params){
                this.params[key] = '';
            }
            this.params.level = 1;
            this.params.type = 1;
            this.params.status = 1;
        },
        predat:function(e){
            if(e){
                for(let key in this.params){
                   if(e[key]){
                       this.params[key] = e[key];
                   }
                }
                this.params.id = e.id;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.text-block{
      font-size: 14px;
     .bName{
          width: 90px;
          padding-top: 8px;
          float: left;
          text-align: right;
     }
     .bContent{
          margin-left: 100px;
          position: relative;
          margin-bottom: 20px;
          .inpText{
              width: 270px;
          }
          .tips{
              font-size: 12px;
              margin-left: 6px;
              color: #999999;
          }

     }

}

.text-block:last-child .bContent{
    margin-bottom: 0px;
}

.cbody{
    padding: 0 54px;
}

</style>

<style lang="css">

.el-dialog__body{
    padding: 12px 20px !important;
}

.el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// upAffair.vue?6f283927